export const sf = [
  {
    id: 0,
    value: "ALR-WBNB",
  },
  {
    id: 1,
    value: "ALR-ALICE",
  },
];

export const currencies = {
  icon: "/assets/images/currency-icons/sushi-btc.png",
  "ALR-WBNB": {
    address: "0x10bfbc5a0751a295c4040f4d3ef3b73419e6b007",
    decimals: 18,
  },
  "ALR-ALICE": {
    address: "0xaa50040d1b969086883a79b324b9cd4565642d99",
    decimals: 18,
  },
};

export const pools = [
  {
    id: 0,
    lpAddress: "0x1d419535b1b7a2c8c95df7ac0bbf237bd5e70f55",
    first: {
      name: "ALR-ALICE",
      address: "0xaa50040d1b969086883a79b324b9cd4565642d99",
      amount: "",
      tier: 2,
    },
    second: {
      name: "ALR-WBNB",
      address: "0x10bfbc5a0751a295c4040f4d3ef3b73419e6b007",
      amount: "",
      tier: 1,
    },
  },
];

export const riskPools = [
  {
    id: 0,
    first: {
      name: "HR BUSD",
      icon: "../assets/images/currency-icons/busd.png",
    },
    second: {
      name: "WBNB",
      icon: "../assets/images/currency-icons/wbnb.png",
    },
  },
  {
    id: 1,
    first: {
      name: "HR WBNB",
      icon: "../assets/images/currency-icons/wbnb.png",
    },
    second: {
      name: "WBNB",
      icon: "../assets/images/currency-icons/wbnb.png",
    },
  },
  {
    id: 2,
    first: {
      name: "HR LINK",
      icon: "../assets/images/currency-icons/chain-link1.png",
    },
    second: {
      name: "WBNB",
      icon: "../assets/images/currency-icons/wbnb.png",
    },
  },
  {
    id: 3,
    first: {
      name: "HR Alice",
      icon: "../assets/images/currency-icons/alice.png",
    },
    second: {
      name: "WBNB",
      icon: "../assets/images/currency-icons/wbnb.png",
    },
  },
  {
    id: 4,
    first: {
      name: "HR CАKE",
      icon: "../assets/images/currency-icons/cake.png",
    },
    second: {
      name: "WBNB",
      icon: "../assets/images/currency-icons/wbnb.png",
    },
  },
  {
    id: 5,
    first: {
      name: "HR XRP",
      icon: "../assets/images/currency-icons/xrp.png",
    },
    second: {
      name: "WBNB",
      icon: "../assets/images/currency-icons/wbnb.png",
    },
  },
  {
    id: 6,
    first: {
      name: "HR ADA",
      icon: "../assets/images/currency-icons/ada.png",
    },
    second: {
      name: "WBNB",
      icon: "../assets/images/currency-icons/wbnb.png",
    },
  },
];
